import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import InputSearch from "../../../components/InputSearch/InputSearch";
import Typography from "../../Typography";
import Table from "../../table/Table";
import TableComunicationOutside from "../../TableComunicationOutside/TableComunicationOutside";
import UserTreatment from "./Drawer/UserTreatment/UserTreatment";
import UserHistory from "./Drawer/UserHistory/UserHistory";
import UserInteraction from "./Drawer/UserInteraction/UserInteraction";
import DealingTag from "./DealingTag/DealingTag";
import NpsLoading from "../../NpsLoading";
import Paperplane from "../../Loading/Paperplane/Paperplane";
import { Tooltippy } from "../../../actions/Tippy";
import PopoverColumnsFilter from "../../../components/popovercolumnsfilter/PopoverColumnsFilter";

import {
  getDealHistoric,
  getDealStatus,
  listDeals,
} from "../../../services/nps/functions";

import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanagerhorizontal.svg";
import { ReactComponent as ColumnFilterIcon } from "../../../build/images/icons/ColumnFilterIcon.svg";

import "./dealing.css";
import Comment from "./Drawer/Comment/Comment";
import CaseDealing from "./Drawer/CaseDealing/CaseDealing";
import { reduceString } from "../../../utils/reduceString";

let exhibColumn = [];

const Dealing = () => {
  /**
   * PERFIL: Se a nota for de 1 a 6, será Detrator(vermelho).
   * Se a nota for 7 e 8, será Neutro(amarelo). Se a nota for
   * 9 e 10, será Promotor(verde)
   */

  const filtersDashboard = useSelector((state) => state.npsfilters);
  const columnsDealing = useSelector((state) => state.columnsDealing);
  const [searchData, setSearchData] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [userHistoryDrawer, setUserHistoryDrawer] = useState(false);
  const [visibleDrawerCase, setVisibleDrawerCase] = useState(false);
  const [visibleDrawerComment, setVisibleDrawerComment] = useState(false);
  const [userInteractionDrawer, setUserInteractionDrawer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hiddenDrawerTreatment, setHiddenDrawerTreatment] = useState(false);
  const [dataMsg, setDataMsg] = useState([]);
  const [loadingDeals, setLoadingDeals] = useState(false);
  const [treatmentData, setTreatmentData] = useState([]);
  const [filteredTreatmentData, setFilteredTreatmentData] = useState([]);
  const [cdrId, setCdrId] = useState(null);
  const [caseId, setCaseId] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  exhibColumn = [
    {
      title: "Unidade",
      exhib: columnsDealing.unit,
    },
    {
      title: "Atendimento",
      exhib: columnsDealing.attendance,
    },
    {
      title: "Cliente",
      exhib: columnsDealing.client,
    },
    {
      title: "Avaliado Em",
      exhib: columnsDealing.ratedIn,
    },
    {
      title: "Resposta",
      exhib: columnsDealing.response,
    },
    {
      title: "Perfil",
      exhib: columnsDealing.profile,
    },
    {
      title: "Nota NPS",
      exhib: columnsDealing.note,
    },
    {
      title: "O.S",
      exhib: columnsDealing.os,
    },
    {
      title: "Atendente",
      exhib: columnsDealing.attendant,
    },
    {
      title: "Status",
      exhib: columnsDealing.status,
    },
  ];

  const tableColumns = [
    {
      Header: "Unidade",
      accessor: "unit",
      id: "unit",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("Unidade"),
    },
    {
      Header: "Atendimento",
      accessor: "attendance",
      id: "attendance",
      disableFilters: true,
      sortType: hoursSorting,
      display: chooseDisplay("Atendimento"),
    },
    {
      Header: "Cliente",
      accessor: "client",
      id: "client",
      disableFilters: true,
      sortType: columnWithTippySorting,
      display: chooseDisplay("Cliente"),
    },
    {
      Header: "Avaliado Em",
      accessor: "ratedIn",
      id: "ratedIn",
      disableFilters: true,
      sortType: hoursSorting,
      display: chooseDisplay("Avaliado Em"),
    },
    {
      Header: "Resposta",
      accessor: "response",
      id: "response",
      disableFilters: true,
      sortType: hoursSorting,
      display: chooseDisplay("Resposta"),
    },
    {
      Header: "Perfil",
      accessor: "profile",
      id: "profile",
      disableFilters: true,
      sortType: profileSorting,
      display: chooseDisplay("Perfil"),
    },
    {
      Header: "Nota NPS",
      accessor: "note",
      id: "note",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("Nota NPS"),
    },
    {
      Header: "O.S",
      accessor: "os",
      id: "os",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("O.S"),
    },
    {
      Header: "Atendente",
      accessor: "attendant",
      id: "attendant",
      disableFilters: true,
      sortType: defaultSorting,
      display: chooseDisplay("Atendente"),
    },
    {
      Header: "Status",
      accessor: "status",
      id: "status",
      disableFilters: true,
      sortType: statusSorting,
      display: chooseDisplay("Status"),
    },
  ];

  function chooseDisplay(nameDisplay) {
    const indexFind = exhibColumn.findIndex(
      (column) => column.title.toLowerCase() === nameDisplay.toLowerCase()
    );

    if (indexFind === -1) {
      return true;
    }
    return exhibColumn[indexFind].exhib;
  }

  function hoursSorting(rowA, rowB, columnId) {
    const rowDataA = rowA.original[columnId];
    const rowDataB = rowB.original[columnId];

    if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "object" &&
      typeof rowDataB.data === "object" &&
      rowDataA.data.type &&
      rowDataB.data.type &&
      rowDataA.data.type === "div" &&
      rowDataB.data.type === "div"
    ) {
      const objectRowA = rowDataA.data.props.children;
      const objectRowB = rowDataB.data.props.children;

      if (
        objectRowA &&
        objectRowB &&
        typeof objectRowA === "string" &&
        typeof objectRowB === "string"
      ) {
        const arrDateRowA = objectRowA.split(" ");
        const arrDateRowB = objectRowB.split(" ");
        let dateRowA = "";
        let hourRowA = "";
        let dateRowB = "";
        let hourRowB = "";

        if (arrDateRowA && arrDateRowA.length >= 1) {
          dateRowA = arrDateRowA[0].split("/").reverse().join("/");

          if (arrDateRowA.length >= 2) {
            hourRowA = arrDateRowA[1];
          }
        }

        if (arrDateRowB && arrDateRowB.length >= 1) {
          dateRowB = arrDateRowB[0].split("/").reverse().join("/");

          if (arrDateRowB.length >= 2) {
            hourRowB = arrDateRowB[1];
          }
        }

        const formatedDateRowA = dateRowA + " " + hourRowA;
        const formatedDateRowB = dateRowB + " " + hourRowB;

        if (formatedDateRowA !== " " && formatedDateRowB !== " ") {
          const rawDateFormateRowA = new Date(formatedDateRowA);
          const rawDateFormateRowB = new Date(formatedDateRowB);
          const dateFormateRowA = rawDateFormateRowA
            ? rawDateFormateRowA.getTime()
            : new Date();
          const dateFormateRowB = rawDateFormateRowB
            ? rawDateFormateRowB.getTime()
            : new Date();

          if (dateFormateRowA === dateFormateRowB) return 0;
          if (dateFormateRowA > dateFormateRowB) return -1;
          if (dateFormateRowB > dateFormateRowA) return 1;
        }
      }

      if (
        objectRowA === "" ||
        objectRowA === null ||
        (objectRowA === undefined && objectRowB === "") ||
        objectRowB === null ||
        objectRowB === undefined
      ) {
        return 0;
      }

      if (
        objectRowA === "" ||
        objectRowA === null ||
        objectRowA === undefined
      ) {
        return 1;
      }

      if (
        objectRowB === "" ||
        objectRowB === null ||
        objectRowB === undefined
      ) {
        return -1;
      }
    }

    return 0;
  }

  function columnWithTippySorting(rowA, rowB, columnId) {
    const rowDataA = rowA.original[columnId];
    const rowDataB = rowB.original[columnId];

    if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "string" &&
      typeof rowDataB.data === "string"
    ) {
      const objectRowA = rowDataA.data.toLowerCase();
      const objectRowB = rowDataB.data.toLowerCase();

      if (objectRowA > objectRowB) return -1;
      if (objectRowB > objectRowA) return 1;
    } else if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "number" &&
      typeof rowDataB.data === "number"
    ) {
      const objectRowA = rowDataA.data;
      const objectRowB = rowDataB.data;

      if (objectRowA > objectRowB) return -1;
      if (objectRowB > objectRowA) return 1;
    } else if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "object" &&
      typeof rowDataB.data === "object" &&
      rowDataA.data.type &&
      rowDataB.data.type &&
      rowDataA.data.type === "div" &&
      rowDataB.data.type === "div"
    ) {
      const objectRowA = rowDataA.data.props.children;
      const objectRowB = rowDataB.data.props.children;

      if (typeof objectRowA === "number" && typeof objectRowB === "number") {
        if (objectRowA > objectRowB) return -1;
        if (objectRowB > objectRowA) return 1;
      } else if (
        typeof objectRowA === "string" &&
        typeof objectRowB === "string"
      ) {
        const objectRowALowerCase = objectRowA.toLowerCase();
        const objectRowBLowerCase = objectRowB.toLowerCase();

        if (objectRowALowerCase > objectRowBLowerCase) return -1;
        if (objectRowBLowerCase > objectRowALowerCase) return 1;
      } else if (
        objectRowA &&
        objectRowB &&
        typeof objectRowA === "object" &&
        typeof objectRowB === "object" &&
        objectRowA.props &&
        objectRowB.props &&
        typeof objectRowA.props === "object" &&
        typeof objectRowB.props === "object" &&
        (objectRowA.props.content || objectRowA.props.content === "") &&
        (objectRowB.props.content || objectRowB.props.content === "")
      ) {
        const contentRowA = objectRowA.props.content;
        const contentRowB = objectRowB.props.content;

        if (
          typeof contentRowA === "string" &&
          typeof contentRowB === "string"
        ) {
          const contentRowALowerCase = contentRowA.toLowerCase();
          const contentRowBLowerCase = contentRowB.toLowerCase();

          if (contentRowALowerCase > contentRowBLowerCase) return -1;
          if (contentRowBLowerCase > contentRowALowerCase) return 1;
        } else if (
          typeof contentRowA === "number" &&
          typeof contentRowB === "number"
        ) {
          if (contentRowA > contentRowB) return -1;
          if (contentRowB > contentRowA) return 1;
        }
      }

      return 0;
    }

    return 0;
  }

  function defaultSorting(rowA, rowB, columnId) {
    const rowDataA = rowA.original[columnId];
    const rowDataB = rowB.original[columnId];

    if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "string" &&
      typeof rowDataB.data === "string"
    ) {
      const objectRowA = rowDataA.data.toLowerCase();
      const objectRowB = rowDataB.data.toLowerCase();

      if (objectRowA > objectRowB) return -1;
      if (objectRowB > objectRowA) return 1;
    } else if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "number" &&
      typeof rowDataB.data === "number"
    ) {
      const objectRowA = rowDataA.data;
      const objectRowB = rowDataB.data;

      if (objectRowA > objectRowB) return -1;
      if (objectRowB > objectRowA) return 1;
    } else if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "object" &&
      typeof rowDataB.data === "object" &&
      rowDataA.data.type &&
      rowDataB.data.type &&
      rowDataA.data.type === "div" &&
      rowDataB.data.type === "div"
    ) {
      const objectRowA = rowDataA.data.props.children;
      const objectRowB = rowDataB.data.props.children;

      if (typeof objectRowA === "number" && typeof objectRowB === "number") {
        if (objectRowA > objectRowB) return -1;
        if (objectRowB > objectRowA) return 1;
      } else if (
        typeof objectRowA === "string" &&
        typeof objectRowB === "string"
      ) {
        const objectRowALowerCase = objectRowA.toLowerCase();
        const objectRowBLowerCase = objectRowB.toLowerCase();

        if (objectRowALowerCase > objectRowBLowerCase) return -1;
        if (objectRowBLowerCase > objectRowALowerCase) return 1;
      }

      return 0;
    }

    return 0;
  }

  function statusSorting(rowA, rowB, columnId) {
    const rowDataA = rowA.original[columnId];
    const rowDataB = rowB.original[columnId];

    if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "object" &&
      typeof rowDataB.data === "object" &&
      rowDataA.data.type &&
      rowDataB.data.type &&
      rowDataA.data.type === "div" &&
      rowDataB.data.type === "div"
    ) {
      const objectRowA = rowDataA.data.props.children;
      const objectRowB = rowDataB.data.props.children;

      if (typeof objectRowA === "number" && typeof objectRowB === "number") {
        if (objectRowA > objectRowB) return -1;
        if (objectRowB > objectRowA) return 1;
      } else if (
        typeof objectRowA === "string" &&
        typeof objectRowB === "string"
      ) {
        const objectRowALowerCase = objectRowA.toLowerCase();
        const objectRowBLowerCase = objectRowB.toLowerCase();

        if (objectRowALowerCase > objectRowBLowerCase) return -1;
        if (objectRowBLowerCase > objectRowALowerCase) return 1;
      } else if (
        objectRowA &&
        objectRowB &&
        objectRowA.props &&
        objectRowB.props &&
        objectRowA.props.value &&
        objectRowB.props.value &&
        typeof objectRowA === "object" &&
        typeof objectRowB === "object"
      ) {
        const childrenObjectRowA = objectRowA.props.value.desc_deal_status
          ? objectRowA.props.value.desc_deal_status
          : "novo";
        const childrenObjectRowB = objectRowB.props.value.desc_deal_status
          ? objectRowB.props.value.desc_deal_status
          : "novo";

        if (
          childrenObjectRowA &&
          childrenObjectRowB &&
          typeof childrenObjectRowA === "string" &&
          typeof childrenObjectRowB === "string"
        ) {
          const childrenObjectRowALowerCase = childrenObjectRowA.toLowerCase();
          const childrenObjectRowBLowerCase =
            childrenObjectRowB.toLocaleLowerCase();

          if (childrenObjectRowALowerCase > childrenObjectRowBLowerCase)
            return -1;
          if (childrenObjectRowBLowerCase > childrenObjectRowALowerCase)
            return 1;
        }
        return 0;
      }

      return 0;
    }
  }

  function profileSorting(rowA, rowB, columnId) {
    const rowDataA = rowA.original[columnId];
    const rowDataB = rowB.original[columnId];

    if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "object" &&
      typeof rowDataB.data === "object" &&
      rowDataA.data.type &&
      rowDataB.data.type &&
      rowDataA.data.type === "div" &&
      rowDataB.data.type === "div"
    ) {
      const rowAChildren = rowDataA.data.props.children;
      const rowBChildren = rowDataB.data.props.children;

      if (
        rowAChildren &&
        rowBChildren &&
        typeof rowAChildren.props === "object" &&
        typeof rowBChildren.props === "object"
      ) {
        const objectRowA = rowAChildren.props.NpsNote;
        const objectRowB = rowBChildren.props.NpsNote;

        if (typeof objectRowA === "number" && typeof objectRowB === "number") {
          if (objectRowA > objectRowB) return -1;
          if (objectRowB > objectRowA) return 1;
        } else if (
          typeof rowDataA.data === "string" &&
          typeof rowDataB.data === "string"
        ) {
          const objectRowALowerCase = objectRowA.toLowerCase();
          const objectRowBLowerCase = objectRowB.toLowerCase();

          if (objectRowALowerCase > objectRowBLowerCase) return -1;
          if (objectRowBLowerCase > objectRowALowerCase) return 1;
        }

        return 0;
      }

      return 0;
    }
    return 0;
  }

  function handleTableDataLookupOnChangePage(event, filteredTreatmentData) {
    const filteredData = filteredTreatmentData.filter(
      (data) =>
        (data.unidade != null &&
          data.unidade !== "" &&
          data.unidade.toLowerCase().includes(event.toLowerCase())) ||
        (data.nota_nps != null &&
          data.nota_nps !== "" &&
          data.nota_nps.toString().includes(event)) ||
        (data.protocolo != null &&
          data.protocolo !== "" &&
          data.protocolo.toLowerCase().includes(event.toLowerCase())) ||
        (data.atendente != null &&
          data.atendente !== "" &&
          data.atendente.toLowerCase().includes(event.toLowerCase())) ||
        (data.desc_deal_status != null &&
          data.desc_deal_status !== "" &&
          data.desc_deal_status !== undefined &&
          data.desc_deal_status.toLowerCase().includes(event.toLowerCase())) ||
        (data.nota_nps != null &&
          data.nota_nps !== "" &&
          data.nota_nps !== undefined &&
          (data.nota_nps === 9 || data.nota_nps === 10) &&
          "promotor".includes(event.toLowerCase())) ||
        (data.nota_nps != null &&
          data.nota_nps !== "" &&
          data.nota_nps !== undefined &&
          (data.nota_nps === 7 || data.nota_nps === 8) &&
          "neutro".includes(event.toLowerCase())) ||
        (data.nota_nps != null &&
          data.nota_nps !== "" &&
          data.nota_nps !== undefined &&
          data.nota_nps >= 0 &&
          data.nota_nps <= 6 &&
          "detrator".includes(event.toLowerCase())) ||
        (data.data_resposta != null &&
          data.data_resposta !== "" &&
          data.data_resposta !== undefined &&
          data.data_resposta.toLowerCase().includes(event.toLowerCase())) ||
        (data.data_atendimento != null &&
          data.data_atendimento !== "" &&
          data.data_atendimento !== undefined &&
          data.data_atendimento.toLowerCase().includes(event.toLowerCase())) ||
        ((data.desc_deal_status === null || data.desc_deal_status === "Novo") &&
          (data.id_deal_status === null || data.id_deal_status === 1) &&
          "novo".includes(event.toLowerCase())) ||
        (data.data_avaliacao != null &&
          data.data_avaliacao !== "" &&
          data.data_avaliacao !== undefined &&
          data.data_avaliacao.toLowerCase().includes(event.toLowerCase())) ||
        (data.nome_cliente != null &&
          data.nome_cliente !== "" &&
          data.nome_cliente !== undefined &&
          data.nome_cliente.toLowerCase().includes(event.toLowerCase()))
    );

    setTreatmentData(filteredData);
    return filteredData;
  }

  function handleTableDataLookup(event) {
    const filteredData = filteredTreatmentData.filter(
      (data) =>
        (data.unidade != null &&
          data.unidade !== "" &&
          data.unidade.toLowerCase().includes(event.toLowerCase())) ||
        (data.nota_nps != null &&
          data.nota_nps !== "" &&
          data.nota_nps.toString().includes(event)) ||
        (data.protocolo != null &&
          data.protocolo !== "" &&
          data.protocolo.toLowerCase().includes(event.toLowerCase())) ||
        (data.atendente != null &&
          data.atendente !== "" &&
          data.atendente.toLowerCase().includes(event.toLowerCase())) ||
        (data.desc_deal_status != null &&
          data.desc_deal_status !== "" &&
          data.desc_deal_status !== undefined &&
          data.desc_deal_status.toLowerCase().includes(event.toLowerCase())) ||
        (data.nota_nps != null &&
          data.nota_nps !== "" &&
          data.nota_nps !== undefined &&
          (data.nota_nps === 9 || data.nota_nps === 10) &&
          "promotor".includes(event.toLowerCase())) ||
        (data.nota_nps != null &&
          data.nota_nps !== "" &&
          data.nota_nps !== undefined &&
          (data.nota_nps === 7 || data.nota_nps === 8) &&
          "neutro".includes(event.toLowerCase())) ||
        (data.nota_nps != null &&
          data.nota_nps !== "" &&
          data.nota_nps !== undefined &&
          data.nota_nps >= 0 &&
          data.nota_nps <= 6 &&
          "detrator".includes(event.toLowerCase())) ||
        (data.data_resposta != null &&
          data.data_resposta !== "" &&
          data.data_resposta !== undefined &&
          data.data_resposta.toLowerCase().includes(event.toLowerCase())) ||
        (data.data_atendimento != null &&
          data.data_atendimento !== "" &&
          data.data_atendimento !== undefined &&
          data.data_atendimento.toLowerCase().includes(event.toLowerCase())) ||
        ((data.desc_deal_status === null || data.desc_deal_status === "Novo") &&
          (data.id_deal_status === null || data.id_deal_status === 1) &&
          "novo".includes(event.toLowerCase())) ||
        (data.data_avaliacao != null &&
          data.data_avaliacao !== "" &&
          data.data_avaliacao !== undefined &&
          data.data_avaliacao.toLowerCase().includes(event.toLowerCase())) ||
        (data.nome_cliente != null &&
          data.nome_cliente !== "" &&
          data.nome_cliente !== undefined &&
          data.nome_cliente.toLowerCase().includes(event.toLowerCase()))
    );

    setTreatmentData(filteredData);
    return filteredData;
  }

  const handleRowClick = (id_cdr) => {
    setIsDrawerOpen(false);
    setCdrId(id_cdr);
    setTimeout(() => {
      setIsDrawerOpen(true);
    }, 200);
  };

  function refactoryTableList(data) {
    let newData = [];

    if (!data) throw new Error("Error when fetching data!");

    data.forEach((value) => {
      const refactoredData = {
        unit: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.unidade ? value.unidade : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        attendance: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.data_atendimento ? value.data_atendimento : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        client: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              <Tooltippy content={value.nome_cliente ? value.nome_cliente : ""}>
                <div>
                  {value.nome_cliente
                    ? reduceString(value.nome_cliente, 13)
                    : ""}
                </div>
              </Tooltippy>
            </div>
          ),
          config: {
            className: "",
          },
        },
        ratedIn: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.data_avaliacao ? value.data_avaliacao : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        response: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.data_resposta ? value.data_resposta : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        profile: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              <DealingTag NpsNote={value.nota_nps} type="profile" />
            </div>
          ),
          config: {
            className: "",
          },
        },
        note: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.nota_nps}
            </div>
          ),
          config: {
            className: "",
          },
        },
        os: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.protocolo ? value.protocolo : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        attendant: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.atendente ? value.atendente : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        status: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              <DealingTag value={value} dealStatusId={value.id_deal_status} />
            </div>
          ),
        },
      };

      newData.push(refactoredData);
    });

    return newData;
  }

  const getlistDeal = async () => {
    setLoading(true);
    const response = await listDeals(
      filtersDashboard.datestart,
      filtersDashboard.dateend,
      filtersDashboard.units.map((option) => option.id).join(),
      filtersDashboard.business.map((option) => option.id).join()
    );

    if (response && response.status !== 200) {
      setLoading(false);
      return [];
    }

    if (response && response.status === 200) {
      setTreatmentData(response.data);
      setFilteredTreatmentData(response.data);
      setLoading(false);
      return response.data;
    }
    setLoading(false);
    return [];
  };

  const tableData = useMemo(() => {
    if (treatmentData) {
      //  setLoading(false);

      return refactoryTableList(treatmentData);
    }
  }, [treatmentData]);

  useEffect(() => {
    if (!searchData) setTreatmentData(filteredTreatmentData);
  }, [searchData]);

  useEffect(() => {
    getlistDeal(
      filtersDashboard.datestart,
      filtersDashboard.dateend,
      filtersDashboard.units.map((option) => option.id).join(),
      filtersDashboard.business.map((option) => option.id).join()
    );
  }, [filtersDashboard]);

  const handleCloseDrawer = () => {
    setHiddenDrawerTreatment(false);
    setVisibleDrawerCase(false);
  };

  let checkSort = localStorage.getItem("sortDealingRow")
    ? JSON.parse(localStorage.getItem("sortDealingRow"))
    : "";

  let sortBy = {
    sortBy: [],
  };

  if (checkSort !== "") {
    sortBy = {
      sortBy: [
        {
          id: checkSort ? checkSort.sort : "agent",
          desc: checkSort ? checkSort.sortDesc : false,
        },
      ],
    };
  }

  return (
    <section className="dealing">
      <div className="dealing-card">
        <header className="dealing-card-header">
          <div className="dealing-card-header__content">
            <Typography.H4 weight="700" color="gray-180">
              Tratativas
            </Typography.H4>

            <div className="dealing-card-header__content__input">
              <InputSearch
                search={searchData}
                setSearch={setSearchData}
                onSearch={() => handleTableDataLookup(searchData)}
                onKeyDown={true}
              />
            </div>
          </div>
        </header>

        <div className="dealing-card__table-container">
          <div className="dealing-card__table-container__filter">
            <PopoverColumnsFilter
              className={"filters-columns"}
              placement="bottom-end"
              menuData={exhibColumn}
              screen="nps_dealing"
            >
              <div className="email__container-subheader__actionsTwo">
                <ColumnFilterIcon />
                <span className="email__container-subheader__actionsTwo-span">
                  Colunas
                </span>
              </div>
            </PopoverColumnsFilter>
          </div>
          {loading ? (
            <Paperplane />
          ) : (
            <>
              {tableData.length > 0 ? (
                <TableComunicationOutside
                  fixedHeader
                  columns={tableColumns}
                  data={tableData}
                  className="dealing-inside-table"
                  classDivWrapperTable="dealing-table-wrapper-table"
                  screen="npsTables"
                  initialState={sortBy}
                  page={page}
                  setPage={setPage}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={setRowsPerPage}
                />
              ) : (
                <div className="dealing-card__table-container__emptyState">
                  <EmptyState />
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {isDrawerOpen &&
        !!filteredTreatmentData.find((item) => item.id_cdr === cdrId) && (
          <UserTreatment
            handleTableDataLookup={handleTableDataLookupOnChangePage}
            searchData={searchData}
            isDrawerOpen={isDrawerOpen}
            setUserHistoryDrawer={setUserHistoryDrawer}
            onCloseDrawer={() => {
              setIsDrawerOpen(false);
              setCdrId(null);
            }}
            caseId={caseId}
            setCaseId={setCaseId}
            setIsDrawerOpen={setIsDrawerOpen}
            setVisibleDrawerComment={setVisibleDrawerComment}
            setVisibleDrawerCase={setVisibleDrawerCase}
            setUserInteractionDrawer={setUserInteractionDrawer}
            hiddenDrawerTreatment={hiddenDrawerTreatment}
            setHiddenDrawerTreatment={setHiddenDrawerTreatment}
            treatmentData={filteredTreatmentData.find(
              (item) => item.id_cdr === cdrId
            )}
            getlistDeal={getlistDeal}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
          />
        )}

      {visibleDrawerCase && (
        <div
          className="drawer-container"
          style={{ width: "49%", height: "100%", maxWidth: "650px" }}
        >
          <CaseDealing
            visibleDrawerCase={visibleDrawerCase}
            caseId={caseId}
            onCloseDrawer={() => handleCloseDrawer()}
            treatmentData={treatmentData.find((item) => item.id_cdr === cdrId)}
          />
        </div>
      )}

      {userHistoryDrawer && (
        <div className="drawer-container">
          <UserHistory
            userHistoryDrawer={userHistoryDrawer}
            onCloseDrawer={() => setUserHistoryDrawer(false)}
            treatmentData={treatmentData.find((item) => item.id_cdr === cdrId)}
          />
        </div>
      )}

      {userInteractionDrawer && (
        <div className="drawer-container">
          <UserInteraction
            userInteractionDrawer={userInteractionDrawer}
            onCloseDrawer={() => setUserInteractionDrawer(false)}
            treatmentData={treatmentData.find((item) => item.id_cdr === cdrId)}
          />
        </div>
      )}

      {visibleDrawerComment && (
        <div className="drawer-container">
          <Comment
            visibleDrawerComment={visibleDrawerComment}
            onCloseDrawer={() => setVisibleDrawerComment(false)}
            treatmentData={treatmentData.find((item) => item.id_cdr === cdrId)}
            dataMsg={dataMsg}
            setDataMsg={setDataMsg}
          />
        </div>
      )}
    </section>
  );
};

export default Dealing;
